/**
 * Where this device's theme is kept. F-0581's first-start check (`deviceGetStarted.ts`) reads it at
 * boot, before `ThemeProvider` stores one.
 */
export const THEME_STORAGE_KEY = 'featit:theme';
